import { memo } from 'react';
import Script from 'next/script';
import { CustomAppEvents } from 'core/common/entities';
import { areArraysOfPrimitivesEqual } from 'core/common/utils/areArraysOfPrimitivesEqual';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { AnalyticsPixelId } from '../../entities';
import { TikTokScriptsService } from '../../services';

export type TikTokScriptsProps = {
  ids: Array<AnalyticsPixelId>;
};

export const TikTokScripts = (props: TikTokScriptsProps) => {
  return (
    <>
      {props.ids.map((id: string) => {
        return (
          <Script
            id={`tiktok-pixel-${id}`}
            key={`tiktok-pixel-${id}`}
            strategy="afterInteractive"
            onReady={() => {
              const event = new Event(CustomAppEvents.TIKTOK_PIXEL_LOADED);
              document.dispatchEvent(event);
            }}
            dangerouslySetInnerHTML={prepareHtml(TikTokScriptsService.getPixelCode())}
          />
        );
      })}
    </>
  );
};

export default memo(TikTokScripts, (prevProps, nextProps) =>
  areArraysOfPrimitivesEqual(prevProps.ids, nextProps.ids),
);
